import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { bdlBoxBlue } from '../../styles/variables';

import { Icon } from '../iconTypes';

const UploadStartState = ({ className = '', color = bdlBoxBlue, height = 85, title, width = 128 }: Icon) => (
    <AccessibleSVG
        className={`upload-start-state ${className}`}
        height={height}
        title={title}
        viewBox="0 0 128 85"
        width={width}
    >
        <path
            className="fill-color"
            d="M0 43L2 43 2 49 8 49 8 43 10 43 5 37 0 43M118 43L120 43 120 49 126 49 126 43 128 43 123 37 118 43M13 24L16 24 16 32 24 32 24 24 27 24 20 16 13 24M98 26L102 26 102 36 112 36 112 26 116 26 107 16 98 26"
            fill={color}
            fillOpacity="0.2"
        />
        <path
            className="fill-color"
            d="M94.16,14.13,81.41.92A3,3,0,0,0,79.25,0H38a3,3,0,0,0-3,3V75a3,3,0,0,0,3,3H92a3,3,0,0,0,3-3V16.21A3,3,0,0,0,94.16,14.13ZM80,2.34,91.26,14H80ZM93,75a1,1,0,0,1-1,1H38a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1H78V16H93a1,1,0,0,1,0,.21Z"
            fill={color}
        />
        <path
            className="fill-color"
            d="M45,50H85V20H45Zm6.08-2L57,40.66l5,6.94,10-11.05,9,11.45ZM47,22H83V47.38L72.05,33.45l-9.95,11L57,37.34,48.52,48H47Z"
            fill={color}
        />
        <circle className="fill-color" cx="54" cy="30" fill={color} r="3" />
        <path
            className="fill-color"
            d="M46.5 56h29a1.5 1.5 0 0 0 0-3h-29a1.5 1.5 0 0 0 0 3zM80.5 59h-34a1.5 1.5 0 0 0 0 3h34a1.5 1.5 0 0 0 0-3zM59.5 65h-13a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3z"
            fill={color}
        />
        <path
            className="fill-color"
            d="M35 63L35 53 35 48.56 30 43 21 53 25 53 25 63 35 63M99 50L95 54.57 95 58 95 66 103 66 103 58 106 58 99 50M76.5 82h-29a1.5 1.5 0 0 0 0 3h29a1.5 1.5 0 0 0 0-3zM88.5 82h-8a1.5 1.5 0 0 0 0 3h8a1.5 1.5 0 0 0 0-3zM43.5 82h-2a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 0-3z"
            fill={color}
            fillOpacity="0.2"
        />
    </AccessibleSVG>
);

export default UploadStartState;
